import { render, staticRenderFns } from "./ProjectModal_Benefits.vue?vue&type=template&id=8e9b41a2&scoped=true&"
import script from "./ProjectModal_Benefits.vue?vue&type=script&lang=js&"
export * from "./ProjectModal_Benefits.vue?vue&type=script&lang=js&"
import style0 from "./ProjectModal_Benefits.vue?vue&type=style&index=0&id=8e9b41a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9b41a2",
  null
  
)

export default component.exports